import { SystemContainerCalculator } from './SystemContainerCalculator'
import { BuildingFragment } from '../generated/graphql'
import { mapDemandToEnergyFlow } from './EnergyFlow'
import { createMapFragmentToProvider } from './providers/util/fragment-to-provider-mapper'

export class BuildingCalculator extends SystemContainerCalculator {
  public multiplier = 1

  public setMultiplier(multiplier: number): void {
    this.multiplier = multiplier
  }
}

export function createMapBuildingToBuildingCalculator(
  temperatureValues?: number[],
) {
  return (building: BuildingFragment): BuildingCalculator => {
    const newBuilding = new BuildingCalculator(building.id)
    newBuilding.setMultiplier(building.multiplier)

    building.demands.map(mapDemandToEnergyFlow).forEach((flow) => {
      newBuilding.addDemand(flow)
    })

    building.providers
      .map(createMapFragmentToProvider(temperatureValues))
      .forEach((provider) => newBuilding.addProvider(provider))

    return newBuilding
  }
}

export function isBuilding(
  container: SystemContainerCalculator,
): container is BuildingCalculator {
  return (container as BuildingCalculator).multiplier !== undefined
}
